import { render } from "./FireVehicleArrived.vue?vue&type=template&id=bdb89794"
import script from "./FireVehicleArrived.vue?vue&type=script&lang=ts"
export * from "./FireVehicleArrived.vue?vue&type=script&lang=ts"
script.render = render

export default script